<template>
    <div id="paintlistformpage">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/menu')"
                icon="arrow-left"
                :label="trans('pages.paintlist_form.back')"
            />
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/processpaintlistoverview')"
                icon="cogs"
                :label="trans('pages.paintlist_form.paint_orders_start_screen')"
            />
            <actions-menu-item
                :v4="true"
                :action="calculateAndOptimize"
                v-if="false"
                icon="calculator"
                :label="trans('pages.paintlist_form.calculate')"
            />
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/paintlistforproduct')"
                icon="calculator"
                :label="trans('pages.paintlist_form.calculate_specific')"
            />
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/paintlistforcolor')"
                icon="calculator"
                :label="trans('pages.paintlist_form.empty_paint_order')"
            />
        </actions-menu>

        <ui5-list v-if="items && items.length">
            <ui5-li
                v-for="list in items"
                :key="list.ID"
                @click="$router.push('/optimizedpaintlistview/' + list.ID)"
                :description="getDescription(list)"
            >
                <i
                    v-if="[2, 3].includes(list.type)"
                    class="fa fa-fast-forward mr-2"
                ></i>
                {{ list.ID }}
                <span
                    class="paintlistred"
                    v-if="list.urgent"
                >
                    !
                </span>
                <span class="text-zinc-500">
                    -
                    {{
                        paintListTypeOptionById(list.type)
                            ? trans(
                                  'paint_lists.types.' +
                                      paintListTypeOptionById(list.type).key
                              )
                            : ''
                    }}
                </span>
            </ui5-li>
        </ui5-list>

        <div
            id="no-more"
            v-if="noMore"
        >
            {{ trans('pages.paintlist_form.no_more_paint_orders') }}
        </div>

        <div id="loader-spinner">
            <spinner-text v-if="loading">
                {{ trans('pages.paintlist_form.fetching_paint_orders') }}
            </spinner-text>
            <br />
            <br />
        </div>
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import SpinnerText from '../components/loader/SpinnerText';
import optimizedPaintListApi from '../api/optimizedPaintList';
import partslistApi from '../api/partslist';
import { paintListTypeOptionById } from '../helpers/PaintListTypeHelper.js';
import localization from '../mixins/localization';

const PER_PAGE = 50;

export default {
    components: {
        SpinnerText,
        ActionsMenu,
        ActionsMenuItem,
    },
    mixins: [localization],
    mounted() {
        this.load();
        this.$bus.$on('bottom-scroll', this.load);
    },
    beforeRouteLeave(to, from, next) {
        this.$bus.$off('bottom-scroll', this.load);
        next();
    },
    data() {
        return {
            loading: false,
            noMore: false,
            items: [],
        };
    },
    methods: {
        paintListTypeOptionById,
        getDescription(list) {
            return (
                list.ral +
                ' ' +
                list.poeder +
                ' - ' +
                list.creationDate +
                ' - ' +
                (list.deadline || '') +
                ' - ' +
                (list.status || '')
            );
        },
        reset() {
            this.noMore = false;
            this.items = [];
        },
        load() {
            if (this.noMore || this.loading) {
                return;
            }

            this.loading = true;
            optimizedPaintListApi
                .list(this.items.length, PER_PAGE)
                .then((response) => {
                    const data = response.data;
                    const items = data.data;
                    if (items.length == 0) {
                        this.noMore = true;
                    } else {
                        this.items = [...this.items, ...items];
                    }
                })
                .catch((error) => {
                    this.noMore = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        calculateAndOptimize() {
            partslistApi.calculate().then(() => {
                this.reset();
                this.load();
            });
        },
    },
};
</script>
